import React, { useState, useEffect, useRef } from 'react'
import { useQuery } from '@apollo/client';
import * as d3 from 'd3';
import thecsvdata from './scatterplot1.csv';
import './pop.css';

const ScatterPlot = (props) => {

    const parentgraph = useRef(null);
    const d3Container = useRef(null);
    const [theWidth, setTheWidth] = useState(0);

    var sectorWidth,leftBegin,rightBegin,xScale,xAxisRight,xAxisLeft,pyramid,legend,leftBarGroup,rightBarGroup;
    
    var style = {
        leftBarColor: '#6c9dc6',
        rightBarColor: '#de5454',
        tooltipBG: '#fefefe',
        tooltipColor: 'black'
    };


    
    const translation = (x, y) => {
        return 'translate(' + x + ',' + y + ')';
    }

    const prettyFormat = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function parseDate(input) {
        var parts = input.match(/(\d+)/g);
        // note parts[1]-1
        return new Date(parts[2], parts[1]-1, parts[0]);
    }

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const colorTransform = (c1, c2) => {
        var c1 = c1.replace('#',''),
            origHex = {
                r: c1.substring(0, 2),
                g: c1.substring(2, 4),
                b: c1.substring(4, 6)
            },
            transVec = {
                r: c2.substring(0, 2),
                g: c2.substring(2, 4),
                b: c2.substring(4, 6)
            },
            newHex = {};

        function transform(d, e) {
            var f = parseInt(d, 16) + parseInt(e, 16);
            if (f > 255) {
                f = 255;
            }
            return f.toString(16);
        }
        newHex.r = transform(origHex.r, transVec.r);
        newHex.g = transform(origHex.g, transVec.g);
        newHex.b = transform(origHex.b, transVec.b);
        return '#' + newHex.r + newHex.g + newHex.b;
    }

    var margin = {
        top: 50,
        right: 50,
        bottom: 50,
        left: 25,
        middle: 20
    };
    
    useEffect(
        () => {
            
            if (thecsvdata !== null && parentgraph) {
                setTimeout(function(){
                d3.csv(thecsvdata).then(csvdata => {
                    //do what you need here
                

                    var width = parentgraph.current.offsetWidth;
                    var height = 800;
                    var shapemargin = 40;
                    
                    var tooltipDiv = d3.select("body").append("div")
                    .attr("class", "tooltip")
                    .style("opacity", 0);
                    
                    var styleSection = d3.select(parentgraph.current).append('style')
                    .text('svg {max-width:100%} \
                    .tooltip {position: absolute;line-height: 1.1em;padding: 7px; margin: 3px;background: ' + style.tooltipBG + '; color: ' + style.tooltipColor + '; pointer-events: none;border-radius: 6px;}')


                    window.addEventListener("resize", handleResize);
                    handleResize();
                    function handleResize() {
                        try {
                            document.getElementById("scatterplot").remove();
                        } catch {
                            // do nothing
                        }

                        setTheWidth(parentgraph.current.getBoundingClientRect().width);

                        var svg;
                        if (theWidth > 0) {
                            svg = d3.select(parentgraph.current)
                            .attr("id","scatterplot")
                            .attr("width", theWidth)
                            .attr("height", (height - margin.top + margin.bottom))
                            .append("g")
                            .attr("transform", `translate(${theWidth/2}, ${height/2})`);  
                        } else {
                            svg = d3.select(parentgraph.current) 
                            .append("svg")
                            .attr("id","scatterplot")
                            .attr("width", parentgraph.current.getBoundingClientRect().width)
                            .attr("height", (height - margin.top + margin.bottom))
                        }
    
                        var clip = svg.append("defs").append("svg:clipPath")
                        .attr("id", "clip")
                        .append("svg:rect")
                        .attr("id", "clip-rect")
                        .attr("x", margin.left)
                        .attr("y", -margin.bottom)
                        .attr('width', parentgraph.current.getBoundingClientRect().width)
                        .attr('height', height);

                        // Add X axis
                        var x = d3.scaleTime()
                            .domain(d3.extent(csvdata, function (d) { return new Date(parseDate(d.theDate)); }))
                            .range([ margin.left-1000, parentgraph.current.getBoundingClientRect().width - margin.right ])
                        const gX = svg.append("g").attr("class", "x-axis")
                        var xAxis = (g, x) => g
                            .attr("transform", "translate(0,"+(height - margin.bottom)+")")
                            .call(d3.axisBottom(x))
                            .select(".domain").remove()     
                            
                        gX.call(xAxis, x);


                        // Add Y axis
                        var y = d3.scaleLinear()
                            .domain([50,0])
                            .range([ 0 - margin.bottom, height - margin.top])
                            .nice()
                        const gY = svg.append("g").attr("class", "y-axis")    
                        var yAxis = (g, y) => g
                            .attr("transform", "translate(" + (margin.left) + ",0)")
                            .call(d3.axisLeft(y).tickSize(-width*1.3))

                        gY.call(yAxis, y);                            


                        // Customization
                        svg.selectAll(".tick line").attr("stroke", "#EBEBEB")

                        // Add X axis label:
                        svg.append("text")
                            .attr("text-anchor", "end")
                            .attr("x", width / 2)
                            .attr("y", height)
                            .attr("font-size","8px")
                            .text("Date");

                        svg.append("text")
                            .attr("text-anchor", "end")
                            .attr("transform", "rotate(-90)")
                            .attr("y", 8)
                            .attr("font-size","8px")
                            .attr("x", -(height/2) + margin.top)
                            .text("Support (%)")

                        // Color scale: give me a specie name, I return a color
                        var color = d3.scaleOrdinal()
                            .domain(["Liberal", "Conservative", "NDP", "BQ","Green","PPC","Other" ])
                            .range([ "#e55453", "#321fdb", "#fab116","#339aff","#2eb85c","#a90dd0","#a7a7a7"])


                        // create a tooltip
                        var Tooltip = svg
                            .append("text")
                            .attr("x", 0)
                            .attr("y", 0)
                            .style("opacity", 0)
                            .style("font-size", 17)

                        // Three function that change the tooltip when user hover / move / leave a cell
                        var mouseover = function(event, d) {
                            Tooltip.style("opacity", 1)
                            var toolTipDate = new Date(parseDate(d.theDate));
                            var dateString;
                            dateString = monthNames[toolTipDate.getMonth()] + " " +toolTipDate.getDate()+ ", " +toolTipDate.getFullYear();
                            d3.selectAll(".myArea").style("opacity", .2)
                            d3.select(this)
                            .style("stroke", "black")
                            .style("opacity", 1);
                            tooltipDiv.transition()
                            .duration(50)
                            .style("opacity", 0.9);
                            tooltipDiv.html("<strong>"+dateString+"</strong><br />"+d.theParty+": "+d.theValue+"%<br />Source: "+d.theFirm)
                            .style("left", (event.pageX) + "px")
                            .style("top", (event.pageY - 28) + "px");

                        }
                        var mouseleave = function(d) {
                            Tooltip.style("opacity", 0)
                            d3.select(this)
                            .style("stroke", "none");
                            d3.selectAll(".myArea").style("opacity", 1).style("stroke", "none");
                            tooltipDiv.transition()
                            .duration(50)
                            .style("opacity", 0);                                
                        }

                        // Add dots
                        var dots = svg.append('g')
                            .attr("clip-path", "url(#clip)")
                            .selectAll("dot")
                            .data(csvdata)
                            .enter()
                            .append("circle")
                            .attr("cx", function (d) { return x(new Date(parseDate(d.theDate))); } )
                            .attr("cy", function (d) { return y(d.theValue); } )
                            .attr("r", 5)
                            .style("fill", function (d) { return color(d.theParty) } )
                            .on("mouseover", mouseover )
                            .on("mouseleave", mouseleave )

                        svg.call(d3.zoom()
                            .scaleExtent([1,8])
                            .on('zoom', zoomed));               

                        
                        function zoomed({transform}) {
                            const zx = transform.rescaleX(x).interpolate(d3.interpolateRound);
                            const zy = transform.rescaleY(y).interpolate(d3.interpolateRound);
                            
                            gX.call(xAxis, zx);
                            gY.call(yAxis, zy);
                            svg.selectAll(".tick line").attr("stroke", "#EBEBEB")

                            dots
                                .attr("transform", transform).attr("r", 5 / transform.k );
                        }

                        }
                                
                        return () => window.removeEventListener("resize", handleResize);
                
                    });
                }, 200);
            }                    
                
        },[parentgraph, d3Container])

    return (
        <div ref={parentgraph} style={{width:'auto', display: 'flex', flexDirection: 'column'}}>
        { parentgraph ? console.log(parentgraph) : ""}
        </div>
    )
  }
  
  export default ScatterPlot;